import Login from "./Login";
import { connect } from "react-redux";
import { getUserFormKey } from "shared/store/app/selectors";
import { updateAppUser } from "shared/store/app/actions";

const mapStateToProps = (state: any) => ({
    formKey: getUserFormKey(state),
});

const mapDispatchToProps = {
    updateAppUser,    
};

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Login);
